/**
 * Venue-wide details shown across the site.
 * Only owner-confirmed facts belong here. Anything still unknown is `null`
 * and is rendered as "To be confirmed" (see TBC below).
 */

export const TBC = "To be confirmed";

export const site = {
  name: "The Grey Wolf",
  // Taken from the official logo artwork.
  tagline: "Wood Fired Pizza & Grill",
  motto: "Great Food · Good Times",
  domain: "thegreywolf.ie",
  url: "https://thegreywolf.ie",
  email: "thegreywolf2026@gmail.com",
  location: {
    pub: "Lyster's Pub",
    area: "Harold's Cross",
    city: "Dublin",
    country: "Ireland",
  },
  // Contact details, links and hours below are FALLBACKS only: the live values
  // come from the portal (Settings -> site_settings via get_public_settings).
  // Shown verbatim wherever the address appears (Find Us, footer, event pages).
  // Live value: portal Settings -> Full Business Address (site_settings.venue_address).
  address: "The Grey Wolf\nInside Lyster's Pub\n236/238 Harold's Cross Road\nDublin 6W, D6W RF44\nIreland",
  phone: null,
  openingHours: null,
  openingHoursWeek: null,
  mapsUrl: null,
  instagramUrl: null,
  facebookUrl: null,
  // WhatsApp contact. Number in international (E.164) format, e.g. "+353...".
  // null = button hidden. Later managed in admin Settings (site_settings table).
  whatsapp: {
    number: null,
    defaultMessage: "Hello The Grey Wolf, I have a question.",
    popupEnabled: true,
    popupText: "Need help? Chat with us on WhatsApp!",
  },
  media: {},
  // Built-in SEO fallbacks; live values come from portal Settings (seo_title / seo_description).
  seoTitle: "The Grey Wolf | Wood-Fired Pizza & Grill, Harold's Cross, Dublin",
  seoDescription: "The Grey Wolf: wood-fired pizza and grill kitchen in Harold's Cross, Dublin. Restaurant, private events and catering.",
};


/**
 * "Get Directions": the exact Google Maps place link configured in the portal,
 * otherwise a Maps search for The Grey Wolf itself (never a substitute venue).
 * No embed, so no third-party scripts or cookies.
 */
export function directionsUrl(settings = site) {
  if (settings?.mapsUrl) return settings.mapsUrl;
  const name = settings?.name || site.name;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${name}, ${site.location.area}, ${site.location.city}`
  )}`;
}

export const WEEKDAYS = [
  ["mon", "Monday"], ["tue", "Tuesday"], ["wed", "Wednesday"], ["thu", "Thursday"],
  ["fri", "Friday"], ["sat", "Saturday"], ["sun", "Sunday"],
];
